.scroll {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.track {
  display: flex;
  width: max-content;
  flex-shrink: 0;
}

.track.tile {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(88px, 1fr);
}

.track.icon {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(70px, 1fr);
}

.tile .link,
.icon .link {
  width: 100%;
}

.pill,
.tile,
.image {
  gap: 16px;
}

.icon {
  gap: 8px;

  @media (--reefer-media-tablet-min) {
    gap: 16px;
  }

  @container category-tabs (width < 768px) {
    gap: 8px;
  }
}

.tab {
  gap: 8px;

  @media (--reefer-media-tablet-min) {
    gap: 12px;
  }

  @container category-tabs (width < 768px) {
    gap: 8px;
  }
}

.unselected:hover :global(.category_icon) {
  transition: transform 150ms;
  transform: scale(1.15);
}

.tab > .unselected:hover {
  padding-bottom: 4px;
  background-color: var(--colors-grays-light);
  border-radius: 8px;
}
